import { Card } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAccessControlProfiles } from '../../hooks/query/use-access-control-profiles';
import { AccessControlProfilesTable } from '../organisms/access-control-profiles-table';

import { PageContainer } from '@/components/molecules/page-container';
import { PageHeader } from '@/components/molecules/page-header';
import { withPermissions } from '@/permissions/can';

const AccessControlProfiles = () => {
  const { t } = useTranslation(['accessControlProfiles']);

  const { data, isLoading, error } = useAccessControlProfiles();

  return (
    <PageContainer helmetPageTitle={t('accessControlProfiles:tab')}>
      <PageHeader title={t('accessControlProfiles:title')} />
      <Card
        variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}>
        <AccessControlProfilesTable
          data={data || []}
          error={error?.response?.data?.message || ''}
          isLoading={isLoading}
        />
      </Card>
    </PageContainer>
  );
};

export default withPermissions(
  permissions => permissions.cannot('read', 'AccessControlProfiles'),
  AccessControlProfiles,
);
